import { ChangeDetectionStrategy, Component, Input, output, ViewEncapsulation } from '@angular/core';
import { FiItemsListType } from '@fi-app/shared/fi-items-list/fi-items-list-type';
import { FiRemoteStateFullDataSource } from '@fi-app/shared/fi-items-list/fi-remote-state-full-data-source';
import { ObjectTypes } from '@fi-app/shared/types/object-type';
import { ILoadDataArgs } from '@fi-app/shared/fi-items-list/fi-data-source-base.directive';
import { IDocumentTemplateUsageTableItem } from '../document-template-confirm-delete-dialog.component';
import { IItemsListDataFetchResult } from '@fi-app/shared/fi-items-list/fi-items-list';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'fi-document-usage-list',
    templateUrl: './document-usage-list.component.html',
    styleUrls: ['./document-usage-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    standalone: false,
    host: {
        class: 'fi-document-usage-list',
    },
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', border: 'none' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class DocumentUsageListComponent extends FiRemoteStateFullDataSource<IDocumentTemplateUsageTableItem> {
    public defaultSortColumnName = 'Name';
    public defaultSortDirection = true;
    public objectType = ObjectTypes.Template;
    public itemsListType = FiItemsListType.Documents;

    public setSelectedItemIdsToDelete = output<number[]>();
    public onUsageClick = output<void>();

    @Input() documentTemplates: IDocumentTemplateUsageTableItem[] = [];

    public onSelectionChanged($event: IDocumentTemplateUsageTableItem[]) {
        super.onSelectionChanged($event);
        this.setSelectedItemIdsToDelete.emit(this.selectedItems().map((item) => item.Id));
    }

    public loadListDataFn(loadArgs: ILoadDataArgs) {
        return new Promise<IItemsListDataFetchResult<IDocumentTemplateUsageTableItem>>((resolve) =>
            resolve({
                Items: this.documentTemplates,
                TotalCount: this.documentTemplates.length,
                LightWeightObjectsForLocalSearch: undefined,
            }),
        );
    }
}
